const copy = {
  emptyState: {
    oops: {
      heading: "Looks like something isn't working",
      description: 'Something went wrong. Try again later.',
    },
    noResult: {
      heading: 'No article is found',
      description: "We couldn't find the article. Please try again later",
    },
    bodyEmpty: {
      heading: 'No content available',
      description: 'There is currently no content for this article.',
    },
  },
  errors: {
    log: (articleId: string): string =>
      `Unable to fetch article ${articleId} due to server error`,
  },
  reactHelmet: {
    title: (articleTitle: string | undefined): string =>
      `${articleTitle} - Twilio Help Center`,
  },
};

export default copy;
